import { combineReducers } from '@ngrx/store';
import { WatchListsFeatureState } from './watch-lists-feature.model';
import { watchListsFeatureEntitiesReducer } from './entities';
import { watchListsStateReducer } from '../common/state/watch-lists-state.reducer';

export const watchListsFeatureReducer = combineReducers<WatchListsFeatureState>({
    entities: watchListsFeatureEntitiesReducer,
    state: watchListsStateReducer,
});
